import React from 'react';
import TOLogo from '../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'

import returnHeaders from './MiscHeaders'

class UnknownErrorView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                        <Image className = "corner-logo absolute" alt = "Toyota" src={require("../../../static/images/Toyota-Logo.svg").default} />
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Sign In</div>
                    </Row>
                    <Row className = "title__TO left">Service Down</Row>
                    {returnHeaders("ERROR", sessionStorage.AP_STYLE)}
                    <div>
                    <a href="/"><Button data-testid = "TryAgainButton" bsPrefix = "float-left button__TO" type = "button" >Try Again</Button></a>
                    </div>
                </div>
            </div>
          </div>
        )
  }
}

export default UnknownErrorView;